export const SIDER_SCROLL_CONTAINER_ATTR = 'data-sider-scroll';

export const getSiderScrollPopupContainer = (triggerNode: HTMLElement): HTMLElement =>
  (triggerNode.closest(`[${SIDER_SCROLL_CONTAINER_ATTR}]`) as HTMLElement | null) ?? document.body;
